import classNames from 'classnames';
import React from 'react';
import Size from '../../types/enum/Size';
import './Avatar.scss';
import IAvatarProps from './AvatarProps';

const Avatar = ({
  firstName,
  lastName,
  image,
  size = Size.MEDIUM,
  color,
  numInitials = 1,
  onClick,
  forwardRef,
  className,
}: IAvatarProps) => {
  function getInitials() {
    let initials = firstName.charAt(0);

    if (numInitials === 2 && lastName && lastName.length) {
      initials += lastName.charAt(0);
    }

    return initials;
  }

  function handleClick(event: React.MouseEvent<HTMLDivElement>) {
    if (onClick) {
      onClick(event);
    }
  }

  const classes = classNames(
    {
      'avatar': true,
      'avatar-clickable': onClick,
      [`avatar-${size}`]: true,
    },
    className
  );

  return (
    <div className={classes} ref={forwardRef} onClick={handleClick} style={{ backgroundColor: color }}>
      {firstName.length > 0 && <div className="avatar-initials">{getInitials()}</div>}
      {image && (
        <div
          className="avatar-image"
          style={{
            backgroundImage: `url(${image})`,
            backgroundColor: color,
          }}
        />
      )}
    </div>
  );
};

export default Avatar;
